import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useSearchHydraulicId(interfaceId: Number, id: number) {
  return useQuery({
    queryKey: [queryKeys.hydraulic],
    queryFn: async () => {
      const { data } = await hydraulicDataConfig.getById(interfaceId, id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useSearchHydraulicId
